<!-- 数量统计 -->
<template>
  <div class="numberGrow-wrap">
    <span ref="numberGrow" :style="{'color':color}" :data-time="time" class="number-grow" :data-value="value">0</span>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    time: {
      type: [Number, String],
      default: 2
    },
    value: {
      type: [Number, String],
      default: 1
    },
    color: {
      type: [String],
      default: '#ffaf00'
    }
  },
  mounted() {
    this.numberGrow(this.$refs.numberGrow)
  },
  methods: {
    numberGrow(ele) {
      const _this = this

      const step = (_this.value * 10) / (_this.time * 1000)
      let current = 0
      let start = 0
      let t = setInterval(function() {
        start += step
        if (start > _this.value) {
          clearInterval(t)
          start = _this.value
          t = null
        }
        if (current === start) {
          return
        }
        current = start
        // ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
        ele.innerHTML = parseInt(current)
      }, 10)
    }
  }
}

</script>

<style scoped>
  .numberGrow-wrap{
    display: inline;
  }
  .number-grow {
    font-family: Arial-BoldMT;
    font-size: 32px;
    /*color: #ffaf00;*/
    /*letter-spacing: 2.67px;*/
  }
</style>
